import React from 'react'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import type { WarningActivityDetails } from '@paintscout/api'
import Highlight from '@paintscout/ui/components/Highlight'
import Typography from '@paintscout/ui/components/Typography'
import ActivityTitle from '../ActivityTitle'
import ActivityFooter from '../ActivityFooter'
import ActivityContent from '../ActivityContent'
import type { ActivityTypeComponentProps } from '../Activity'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'

import ActivityOwner from '../ActivityOwner'

const useStyles = makeStyles<Theme, ActivityTypeComponentProps<WarningActivityDetails>>((theme: Theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  message: {
    color: theme.palette.text.secondary,
    whiteSpace: 'pre-wrap'
  }
}))

export default function QuoteWarningActivity(props: ActivityTypeComponentProps<WarningActivityDetails>) {
  const { activity, showDocTypeDetails } = props
  const classes = useStyles(props)

  const warningMessage = activity.details.warningMessage
  const warningTitle = activity.details?.warningTitle

  return (
    <>
      <ActivityTitle>
        <Highlight>{warningTitle}</Highlight>
        {showDocTypeDetails && <ActivityOwner activity={activity} />}
      </ActivityTitle>
      {warningMessage && (
        <ActivityContent className={classes.content}>
          <Typography variant="subtitle2" className={classes.message}>
            {warningMessage}
          </Typography>
        </ActivityContent>
      )}

      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
